import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { LoginType } from "pages/login/types";
import { EmailType } from "sagas/types/login";
import { RootState } from "store";
import { LoginStateType, RestorePasswordActionsTypes } from "./types/login";

export const initialState: LoginStateType = {};

const SLICE_NAME = "login";

export const loginSlice = createSlice({
  name: SLICE_NAME,
  initialState,
  reducers: {
    getLoginRequest: (
      state: LoginStateType,
      action: PayloadAction<LoginType>
    ) => {},
    getLoginSuccess: (state: LoginStateType) => {},
    getLoginError: () => {},
    getLoginEmailRequest: (
      state: LoginStateType,
      action: PayloadAction<EmailType>
    ) => {},
    getLoginEmailSuccess: (state: LoginStateType) => {},
    getLoginEmailError: () => {},
    getLoginRestoreRequest: (
      state: LoginStateType,
      action: PayloadAction<RestorePasswordActionsTypes>
    ) => {},
    getLoginRestoreSuccess: (state: LoginStateType) => {},
    getLoginREstoreError: () => {},
    logout: (state: LoginStateType) => {
      state = initialState;
    },
  },
});

export default loginSlice.reducer;

export const loginSelector = (state: RootState) => state.login;

export const actions = loginSlice.actions;
